if (!window.__ctaBandScrollTopBound) {
  window.__ctaBandScrollTopBound = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-scroll-top]');
    if (!trigger) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}
